// extracted by mini-css-extract-plugin
export default {"SignUp":"SignUp_SignUp__kG8RV","message":"SignUp_message__NphVz","actions":"SignUp_actions__8iTRc"};